import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import root from '@/pages/login/root'
import login from '@/pages/login/login'
import forgetpassword from '@/pages/login/forgetpassword'
import overview from '@/pages/overview/overview'
import detail from '@/pages/questionnaire/questionnaire'
import registration from '@/pages/registration/registration'
import faq from '@/pages/faq/faq'
import result from '@/pages/questionnaire/result'
Vue.use(Router)

let router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Root',
      meta: {
        layout: 'default',
        login: true,
        auth: false
      },
      query: {
        allowed: false
      },
      component: root
    },
    {
      path: '/:countrycode/login',
      name: 'Login',
      meta: {
        layout: 'default',
        auth: false
      },
      params: {
        allowed: false
      },
      component: login,
      beforeEnter: (to, from, next) => {
        // This page can only be entered from the root page and when params.allowed equals true.
        if (from.meta.login && to.params.allowed) {
          next()
        } else {
          next(`/`)
        }
      }
    },
    {
      path: '/:countrycode/password-reset/:forgotpasswordtoken',
      name: 'Forgot password',
      meta: {
        layout: 'default',
        login: true,
        auth: false
      },
      component: forgetpassword
    },
    {
      path: '/:countrycode/registration',
      name: 'Registration',
      meta: {
        layout: 'default',
        auth: true
      },
      component: registration
    },
    {
      path: '/:countrycode/questionnaires',
      name: 'Questionnaires overview',
      meta: {
        layout: 'default',
        auth: true
      },
      component: overview
    },
    {
      path: '/:countrycode/questionnaire/:id',
      name: 'Questionnaire detail page',
      meta: {
        layout: 'default',
        auth: true
      },
      component: detail
    },
    {
      path: '/:countrycode/reporting-obligation/:id',
      name: 'Questionnaire result page',
      meta: {
        layout: 'default',
        auth: true
      },
      component: result
    },
    {
      path: '/:countrycode/information',
      name: 'FAQ',
      meta: {
        layout: 'default',
        auth: true
      },
      component: faq
    }
  ]
})

import helpers from '@/plugins/helpers'
import config from '@/config'
router.beforeEach(async (to, from, next) => {
  if (process.env.NODE_ENV != 'development') {
    if (to.meta.auth) {
      if (!store.state.general.user.id) {
        let userResponse = await helpers.fetchApi(config.apiUrl + 'authentication/user', 'get')
        if (userResponse.id) {
          store.commit('general/SET_USER', userResponse)
          store.commit('general/SET_CURRENT_COUNTRY_CODE', userResponse.countrycode)
          next()
        } else {
          next(`/`)
        }
      }
    } else {
      if (store.state.general.user.id) {
        next(`/${store.state.general.countrycode}/questionnaires`)
      }
    }
  }
  next()
})

export default router
